import React, { useEffect, useState } from "react";
import { auth, db } from "../../firebase";
import {
    collection,
    query,
    where,
    getDocs,
    doc,
    getDoc,
} from "firebase/firestore";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Link } from "react-router-dom";

const DashboardHome = () => {
    const [properties, setProperties] = useState([]);
    const [bookingsCount, setBookingsCount] = useState(0);
    const [voornaam, setVoornaam] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            const user = auth.currentUser;
            if (!user) return;

            // 🔹 Profiel ophalen
            const profileRef = doc(db, "users", user.uid);
            const profileSnap = await getDoc(profileRef);
            if (profileSnap.exists()) {
                const profile = profileSnap.data();
                setVoornaam(profile.voornaam || "");
            }

            // 🔹 Woningen ophalen
            const q = query(collection(db, "properties"), where("userId", "==", user.uid));
            const querySnapshot = await getDocs(q);

            const props = [];
            let totalBookings = 0;

            for (const docSnap of querySnapshot.docs) {
                const prop = { id: docSnap.id, ...docSnap.data() };

                const slotsRef = collection(db, "properties", docSnap.id, "timeslots");
                const slotsSnap = await getDocs(slotsRef);
                const geboekte = slotsSnap.docs.filter((slot) => slot.data().booked).length;

                prop.bookings = geboekte;
                totalBookings += geboekte;

                props.push(prop);
            }

            setProperties(props);
            setBookingsCount(totalBookings);
        };

        fetchData();
    }, []);

    return (
        <DashboardLayout>
            <div className="max-w-5xl mx-auto space-y-10">
                {/* Welkom + CTA */}
                <div className="text-center">
                    <h1 className="text-2xl font-semibold mb-2">
                        Welkom terug{voornaam ? ` ${voornaam}` : ""} 👋
                    </h1>
                    <p className="text-gray-600 mb-6">
                        Hier is een overzicht van je woningen en bezichtigingen.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/dashboard/add"
                            className="bg-[#175151] text-white px-4 py-2 rounded hover:bg-[#148c87] transition flex items-center gap-2 justify-center"
                        >
                            <span className="text-white">✓</span> Woning toevoegen
                        </Link>
                        <Link
                            to="/dashboard/properties"
                            className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300 transition"
                        >
                            🏠 Mijn woningen
                        </Link>
                    </div>
                </div>

                {/* Statistieken */}
                <div className="grid grid-cols-2 gap-4 text-center">
                    <div className="bg-white p-6 rounded shadow">
                        <h3 className="text-sm text-gray-500">Aantal woningen</h3>
                        <p className="text-2xl font-bold">{properties.length}</p>
                    </div>
                    <div className="bg-white p-6 rounded shadow">
                        <h3 className="text-sm text-gray-500">Totaal geboekte tijdsloten</h3>
                        <p className="text-2xl font-bold">{bookingsCount}</p>
                    </div>
                </div>

                {/* Laatste woningen - alleen tonen als er woningen zijn */}
                {properties.length > 0 && (
                    <div>
                        <h2 className="text-lg font-semibold mb-4">Laatste woningen</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {properties.slice(0, 3).map((property) => (
                                <div
                                    key={property.id}
                                    className="bg-white p-4 rounded shadow flex justify-between gap-4"
                                >
                                    <div className="flex-1">
                                        <h3 className="text-md font-semibold">{property.title}</h3>
                                        <p className="text-sm text-gray-500">{property.address}</p>
                                        <p className="text-xs text-gray-500 mb-1">{property.description}</p>
                                        <p className="text-xs text-gray-600">
                                            📅 {property.bookings} bezichtigingen gepland
                                        </p>
                                        <Link
                                            to={`/dashboard/properties/${property.id}/timeslots`}
                                            className="text-sm text-blue-600 hover:underline mt-1 inline-block"
                                        >
                                            Tijdsloten beheren →
                                        </Link>
                                    </div>

                                    {property.woningFotoUrl && (
                                        <div className="w-20 h-20 flex-shrink-0">
                                            <img
                                                src={property.woningFotoUrl}
                                                alt="Woning"
                                                className="w-full h-full object-cover rounded"
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </DashboardLayout>
    );
};

export default DashboardHome;
